const TERM_CLASS = "glossary-term"
const SKIP_SELECTOR = "a, button, script, style, code, pre, textarea, input, select, noscript, .glossary-term, .glossary-skip, [data-glossary-skip]"

function shouldSkip(node) {
  const parent = node.parentElement
  if (!parent) return true
  return Boolean(parent.closest(SKIP_SELECTOR))
}

function buildRegex(terms) {
  const patterns = terms
    .flatMap((term) => term.patterns.map((pattern) => ({ pattern, term })))
    .sort((a, b) => b.pattern.length - a.pattern.length)

  const alternation = patterns
    .map(({ pattern }) => pattern.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"))
    .join("|")

  return new RegExp(`(?<![\\w/])(${alternation})(?![\\w/])`, "gi")
}

function patternMap(terms) {
  const map = new Map()
  terms.forEach((term) => {
    term.patterns.forEach((pattern) => {
      map.set(pattern.toLowerCase(), term)
    })
  })
  return map
}

function createTermButton(match, term) {
  const btn = document.createElement("span")
  btn.className = TERM_CLASS
  btn.tabIndex = 0
  btn.setAttribute("role", "button")
  btn.dataset.glossaryId = term.id
  btn.setAttribute("aria-label", `${term.label}: tap for definition`)
  btn.textContent = match
  return btn
}

function glossaryizeTextNode(textNode, regex, lookup) {
  const text = textNode.textContent
  const matches = [...text.matchAll(regex)]
  if (matches.length === 0) return

  const frag = document.createDocumentFragment()
  let last = 0

  matches.forEach((match) => {
    const index = match.index
    const value = match[0]
    const term = lookup.get(value.toLowerCase())
    if (!term) return

    if (index > last) {
      frag.appendChild(document.createTextNode(text.slice(last, index)))
    }
    frag.appendChild(createTermButton(value, term))
    last = index + value.length
  })

  if (last < text.length) {
    frag.appendChild(document.createTextNode(text.slice(last)))
  }

  textNode.parentNode.replaceChild(frag, textNode)
}

export function linkGlossaryTerms(root, terms) {
  if (!root || !terms?.length) return
  if (root.dataset.glossaryLinked === "true") return

  const regex = buildRegex(terms)
  const lookup = patternMap(terms)
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT)
  const nodes = []

  while (walker.nextNode()) {
    const node = walker.currentNode
    if (!node.textContent.trim()) continue
    if (shouldSkip(node)) continue
    nodes.push(node)
  }

  nodes.forEach((node) => glossaryizeTextNode(node, regex, lookup))
  root.dataset.glossaryLinked = "true"
}
